import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spinner } from 'react-bootstrap';

import { useHttpUtils } from '../../../Utilities/useHttpUtils';
import useAlert from '../../../Alerts/useAlert';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import usePrivileges from '../../../Auth/usePrivileges';

function ExportCollectionUpdateButton() {

    const { t } = useTranslation();
    const { setAlert } = useAlert();
    const { fetchBlobAuthenticated, downloadFile } = useHttpUtils();

    const { lotDetail: {
        summary: {
            businessUnitCode,
            lotNumber,
            lotRevisionId }
    } } = useContext(LotDetailContext);

    const { admin } = usePrivileges(businessUnitCode);
    const [loading, setLoading] = useState<boolean>(false);

    const exportCollectionUpdate = () => {
        setLoading(true);

        let url = `api/v1/lot/${lotNumber}/collectionUpdate`;
        if (lotRevisionId) {
            url += `?revisionId=${lotRevisionId}`;
        }

        fetchBlobAuthenticated(url)
            .then(response => {
                if (response.ok) {
                    return response.blob();
                } else {
                    throw new Error("Failed to get Collection Update");
                }
            })
            .then((response) => {
                return response = response.slice(0, response.size, "application/xml");
            })
            .then(blob => {
                downloadFile(blob, `CollectionUpdate-${lotNumber}.xml`);
            })
            .catch(error => {
                setAlert("danger", "Error", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Button variant="primary"
            disabled={loading}
            hidden={!admin}
            onClick={() => exportCollectionUpdate()}>
            {t('LotDetails.Summary.ExportLot')}
            {loading &&
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="ms-2"
                />
            }
        </Button>
    );
}

export default ExportCollectionUpdateButton;